const maskOrigin = {
    name: "mask-origin",
    path: "mask-origin",
    title: "mask-origin",
    description: "Utilities for controlling the CSS mask-origin property.",
    value: {
        'mask-origin': {
            'mask-origin-content': 'content-box',
            'mask-origin-border': 'border-box',
            'mask-origin-padding': 'padding-box',
            'mask-origin-view': 'view-box',
            'mask-origin-fill': 'fill-box',
            'mask-origin-stroke': 'stroke-box',
        },
    },
    exampleData: [
        {
            "title": "mask-origin-border, mask-origin-padding, mask-origin-content",
            "description": "to control where an element's mask is rendered:",
            "moreDescription": "",
            "parentClass": "flex justify-around gap-6 !bg-none !border-0 pt-10 py-5 !mt-10",
            "example": {
                "element": "img",
                "src": [
                     {
                        "text": "mask-origin-border",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",  
                        "divClass":"relative size-32 aspect-square rounded-lg border-3 border-style-dashed border-color-indigo-500/50 dark:border-color-indigo-400/75",
                        "childDivClass":"absolute bg-cover inset-[-3px] rounded-full bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)]  mask-image-[radial-gradient(circle,_black_100%,_rgba(0,_0,_0,_0)_100%)] mask-no-repeat mask-origin-border p-2",
                    },
                    {
                        "text": "mask-origin-padding",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"relative size-32 aspect-square rounded-lg border-3 border-style-dashed border-color-indigo-500/50 dark:border-color-indigo-400/75",
                        "childDivClass":"absolute bg-cover inset-[-3px] rounded-full bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)]  mask-image-[radial-gradient(circle,_black_100%,_rgba(0,_0,_0,_0)_100%)] mask-no-repeat mask-origin-padding p-2",
                    },
                    {
                        "text": "mask-origin-content",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"relative size-32 aspect-square rounded-lg border-3 border-style-dashed border-color-indigo-500/50 dark:border-color-indigo-400/75",
                        "childDivClass":"absolute bg-cover inset-[-3px] rounded-full bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)]  mask-image-[radial-gradient(circle,_black_100%,_rgba(0,_0,_0,_0)_100%)] mask-no-repeat mask-origin-content p-2",
                    },
                ],
                "className": "relative",
                "code": `<div class="mask-origin-border border-3 p-1.5 mask-image-[url(/img/circle.png)] bg-image-[url(/img/mountains.jpg)] ..."></div>
<div class="mask-origin-padding border-3 p-1.5 mask-image-[url(/img/circle.png)] bg-image-[url(/img/mountains.jpg)] ..."></div>
<div class="mask-origin-content border-3 p-1.5 mask-image-[url(/img/circle.png)] bg-image-[url(/img/mountains.jpg)] ..."></div>`
            }
        }
    ]
};

export default maskOrigin;